<script setup lang="ts">
import LoadingSpinner from '../../base/LoadingSpinner.vue'
import { amountFormatter } from '../../../utilities/helpers'
import { getAccountLink } from '../../../utilities/useLinks'
import { onMounted } from 'vue'
import { replaceCurrencyWithCurrencySymbol } from '../../../utilities/helpers'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'

//@ts-ignore
const accountState = useLegalAccountDataState()

onMounted(async () => {
    await accountState.fetchAccountData()
})
</script>

<template>
    <!-- Aside content -->
    <aside v-if="accountState.loaded">
        <div class="box-shadow mb-4 bg-white p-3">
            <div class="d-flex align-items-center flex-wrap justify-between text-secondary">
                <div class="">
                    <p class="align-items-center d-flex bold mb-0 text-secondary">
                        <span class="ion-ios-business large mr-2"></span>
                        {{ $t('legal_account.company_profile') }}
                    </p>
                </div>

                <div class="text-right">
                    <a :href="getAccountLink()" class="bold text-secondary">
                        <span class="ion-edit mr-2"></span>{{ $t('account_settings.edit') }}
                    </a>
                </div>
            </div>
            <hr />
            <div class="d-flex align-items-center flex-wrap">
                <div
                    v-if="accountState.legalProfile.company_name"
                    class="spot d-flex align-items-center xlarge mr-3 justify-center rounded bg-primary text-white">
                    {{ accountState.legalProfile.company_name.toString().substring(0, 1) }}
                </div>
                <div class="flex-1">
                    <h4 class="text-gray-blue d-i-block mr-3">
                        <strong>
                            {{ accountState.legalProfile.company_name }}
                        </strong>
                    </h4>
                </div>
            </div>
            <hr />

            <div
                v-if="
                    accountState.legalProfile ||
                    accountState.legalProfile.postal_code ||
                    accountState.legalProfile.city ||
                    accountState.legalProfile.state ||
                    accountState.legalProfile.country
                "
                class="investor-address">
                <p class="text-gray-blue d-flex align-items-center">
                    <span class="icon ion-ios-location large mr-2"></span>
                    {{
                        `
                            ${accountState.legalProfile.address ? `${accountState.legalProfile.address}, ` : ``}
                            ${accountState.legalProfile.postal_code ? `${accountState.legalProfile.postal_code}, ` : ``}
                            ${accountState.legalProfile.city ? `${accountState.legalProfile.city}` : ``}
                        `
                    }}
                </p>
                <p
                    v-if="accountState.legalProfile.state || accountState.legalProfile.country"
                    class="text-gray-blue d-flex align-items-center mb-0">
                    <span class="icon ion-map large mr-2"></span>
                    {{
                        `
                          ${accountState.legalProfile.state ? `${accountState.legalProfile.state}, ` : ``}
                          ${accountState.legalProfile.country ? `${accountState.legalProfile.country}` : ``}
                        `
                    }}
                </p>
            </div>
        </div>

        <div v-if="accountState.legalProfile.portfolio_sum.length" class="box-shadow mb-4 bg-white p-3">
            <strong>{{ $t('portfolio_size') }}: </strong>
            <span v-for="(ps, index) in accountState.legalProfile.portfolio_sum" :key="index">
                {{ amountFormatter(ps.portfolio_sum) }} {{ replaceCurrencyWithCurrencySymbol(ps.currency) }}
                <br />
            </span>
        </div>
    </aside>
    <div v-else class="flex h-[65vh] items-center justify-center">
        <LoadingSpinner class="h-10 w-10 fill-primary" />
    </div>
    <!-- End Aside content -->
</template>

<style scoped></style>
